import Vue from 'vue'
import Router from 'vue-router'
import ListAction from '@/components/delivery/action/ListAction'
import CreateAction from '@/components/delivery/action/CreateAction'
import UpdateAction from '@/components/delivery/action/UpdateAction'
import ListDomain from '@/components/delivery/domain/ListDomain'
import CreateDomain from '@/components/delivery/domain/CreateDomain'
import UpdateDomain from '@/components/delivery/domain/UpdateDomain'
import ListFrame from '@/components/delivery/frame/ListFrame'
import GetFrame from '@/components/delivery/frame/GetFrame'
import CreateFrame from '@/components/delivery/frame/CreateFrame'
import UpdateFrame from '@/components/delivery/frame/UpdateFrame'
import ListDecisionTree from '@/components/udata/decisiontree/ListDecisionTree'
import CreateDecisionTree from '@/components/udata/decisiontree/CreateDecisionTree'
import UpdateDecisionTree from '@/components/udata/decisiontree/UpdateDecisionTree'
import Error from '@/components/error/Error'
import HealthCheck from '@/components/HealthCheck'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {path: '/delivery/list-action', name: 'listAction', component: ListAction}, // アクションリスト
    {path: '/delivery/create-action', name: 'createAction', component: CreateAction}, // アクションの新規登録
    {path: '/delivery/update-action', name: 'updateAction', component: UpdateAction}, // アクションの詳細、編集
    {path: '/delivery/list-domain', name: 'listDomain', component: ListDomain}, // ドメインリスト
    {path: '/delivery/create-domain', name: 'createDomain', component: CreateDomain}, // ドメインの新規登録
    {path: '/delivery/update-domain', name: 'updateDomain', component: UpdateDomain}, // ドメインの詳細、編集
    {path: '/delivery/list-frame', name: 'listFrame', component: ListFrame}, // 枠一覧
    {path: '/delivery/get-frame', name: 'getFrame', component: GetFrame}, // 枠の詳細
    {path: '/delivery/create-frame', name: 'createFrame', component: CreateFrame}, // 枠の新規登録
    {path: '/delivery/update-frame', name: 'updateFrame', component: UpdateFrame}, // 枠の詳細、編集
    {path: '/udata/list-decision-tree', name: 'listDecisionTree', component: ListDecisionTree}, // 決定木リスト
    {path: '/udata/create-decision-tree', name: 'createDecisionTree', component: CreateDecisionTree}, // 決定木の新規登録
    {path: '/udata/update-decision-tree', name: 'updateDecisionTree', component: UpdateDecisionTree}, // 決定木の詳細、編集
    {path: '/error/:code', name: 'error', component: Error}, // エラー
    {path: '/healthcheck.txt', name: 'healthcheck', component: HealthCheck}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js